<template>
    <div>
        <mu-flex justify-content="start" align-items="center" class="title">
            <font-awesome-icon icon="star" />
            <mu-title type="h3" color="primary" textStrong="300">Favoritos</mu-title>
        </mu-flex>
        <mu-row class="shortcuts">
            <mu-col span="12" sm="12" md="6" lg="6" xl="6" v-for="(item, key) in shortcuts" :key="key">
                <mu-favorite :favorite="item"></mu-favorite>
            </mu-col>
            <mu-col span="12" sm="12" md="10" lg="10" xl="10" v-if="shortcuts.length == 0" class="empty">
                Você não selecionou nenhum atalho. Acesse <router-link :to="{ name: 'app.profile' }"><u>suas preferências</u></router-link> para gerenciar.
            </mu-col>
        </mu-row>
    </div>
</template>

<script>
    import Menu from '@/config/menu'
    import ProfileServices from '@/services/profile/user'

    export default {
        name: 'app-favorite-profile',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                shortcuts: []
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        created () {
            this.loadShortcuts()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega os os atalhos do usuário
             */
            async loadShortcuts () {
                try {
                    let result = await ProfileServices.find()

                    if (result && result.status) {
                        this.shortcuts = await Menu.findByKeys(JSON.parse(result.results.shortcuts || '[]'))
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../assets/stylus/bootstrap.styl'

    .title
        svg
            font-size 10px
            color $primary
            margin-right 4px
        h3
            margin 0
            font-size 12px
            text-transform uppercase
            font-weight bold

    .empty
        a
            color $primary

</style>
